import HelpTooltip from "components/general/HelpTooltip";
import { Box, Paragraph, Text } from "components/ui";
import React from "react";
import { Col, Container as FlexGridContainer, Row } from "react-native-flex-grid";
import { Group, usePutGroupByIdMutation, User, UserGroup } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import UserLabel from "../form/UserLabel";
import UserGroupForm from "./UserGroupForm";

interface UserAccessControlViewModeProps {
	isEditMode: boolean;
	group: Group;
	id?: string;
}

const UserAccessControlViewMode = ({ isEditMode, group, id }: UserAccessControlViewModeProps) => {
	const [putGroup, { data: putData, isLoading: putIsLoading, isError: putIsError, isSuccess: putIsSuccess }] = usePutGroupByIdMutation();
	const isMobile = useIsMobile();
	function handleUserGroupChange(value: any, usergroupname: string | null | undefined) {
		const userGroupIndex = group?.userGroup?.findIndex((ug) => ug.name === usergroupname);
		if (userGroupIndex !== undefined && userGroupIndex !== -1) {
			const newUserGroups = [...(group?.userGroup || [])];
			newUserGroups[userGroupIndex] = value;

			const newGroup = {
				...group,
				userGroup: newUserGroups,
			};
			newGroup.id = Number(id);
			putGroup({ id: Number(id), group: newGroup });
		}
	}

	if (isEditMode) {
		return (
			<Box>
				{group.userGroup?.map((userGroup: UserGroup, key: number) => {
					return (
						<Box zIndex={9 - key} position="relative">
							<UserGroupForm key={userGroup.name} userGroup={userGroup} onChange={handleUserGroupChange} masterGroup={group.parent == null} />
						</Box>
					);
				})}
			</Box>
		);
	}

	return (
		<FlexGridContainer style={{ rowGap: 16 }} noPadding fluid>
			{group.userGroup?.map((userGroup: UserGroup) => {
				if (userGroup == null || userGroup.userCollection == null) {
					return null;
				}

				return (
					<Row style={{ flexDirection: isMobile ? "column" : "row" }} key={userGroup.name}>
						<Col xs={isMobile ? "auto" : 4}>
							<Box flexDirection="row" alignItems="center" gap={8}>
								<Paragraph fontWeight={"bold"}>{userGroup.name}</Paragraph>
							</Box>
						</Col>
						<Col>
							<Box alignContent="center" flexDirection="row" alignItems="center" gap={8} flexWrap="wrap">
								{group.parent && (
									<Text fontWeight={"$bold"} fontSize={12}>
										Same as {group.parent.name}
									</Text>
								)}
								{userGroup.userCollection.length > 0 ? (
									userGroup.userCollection.map((user: User, index) => {
										return <UserLabel key={index} firstname={user.firstName ?? ""} lastname={user.lastName ?? ""} />;
									})
								) : (
									<Box paddingHorizontal={12} paddingVertical={8}>
										{!group.parent && (
											<Text fontWeight={"$bold"} fontSize={12}>
												No users
											</Text>
										)}
									</Box>
								)}
							</Box>
						</Col>
					</Row>
				);
			})}
		</FlexGridContainer>
	);
};

export default UserAccessControlViewMode;
